export const PAYMENT_TERM = "v1/payment-terms";
